import { render, staticRenderFns } from "./Type9Block.vue?vue&type=template&id=1a462014&scoped=true&"
import script from "./Type9Block.vue?vue&type=script&lang=js&"
export * from "./Type9Block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a462014",
  null
  
)

export default component.exports